import IConfigText from './Interfaces/IConfigText';

class ConfigText implements IConfigText {
    public liveLabel = 'Live';

    constructor() {
        Object.seal(this);
    }
}

export default ConfigText;